<template>
  <v-container class="mt-16 animate__animated animate__fadeIn">
    <v-row>
      <v-col cols="12">

        <v-card
          outlined
          height="150"
        >
          <v-card-text>
            <v-row>
              <v-col cols="1">
                <v-avatar size="100">
                  <img
                    :src="record.logo"
                    alt=""
                    srcset=""
                  >
                </v-avatar>
              </v-col>
              <v-col
                cols="6"
                class="pl-10"
              >
                <div class="ant-font-viga ant-title">
                  {{ record.name }}
                </div>
                <div class="text-body-2">
                  {{ record.location }}
                </div>
                <div>
                  <v-chip
                    class="white--text"
                    small
                    :color="record.status.color"
                  >{{ record.status.text }}</v-chip>
                </div>
                <div class="mt-5">
                  <v-row>
                    <v-col cols="3">
                      <v-btn
                        block
                        class="blue white--text"
                      >Ikuti</v-btn>
                    </v-col>
                    <v-col cols="9">
                      <v-btn
                        outlined
                        class="blue--text"
                        @click="openShareProduct"
                      >
                        <v-icon>
                          mdi-share-variant-outline
                        </v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
              <v-col cols="5">
                <v-row>
                  <v-col cols="4">
                    <div class="pt-2"><v-icon
                        color="orange"
                        class="mr-2"
                      >mdi-star</v-icon><span class="ant-font-viga ant-title pt-10">0</span></div>

                  </v-col>
                  <v-col cols="1">
                    <v-divider vertical></v-divider>
                  </v-col>
                  <v-col cols="7">
                    <div class="ant-font-viga ant-title">10.00 s.d 23.00</div>
                    <div class="text-body-2">Jam Operasional UMKM</div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <div class="ant-font-viga ant-title">Etalase Produk</div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="3">
        <v-card>
          <v-card-title class="ant-blue white--text">
            <v-icon class="mr-2 white--text">mdi-view-headline</v-icon>
            Semua Kategori</v-card-title>
          <v-card-text>
            <v-list
              dense
              nav
              shaped
            >

              <template v-for="(menu, index) in categories">
                <v-list-item
                  active-class="orange darken-4"
                  :to="menu.route"
                  :key="index"
                  v-if="menu.type === 'item'"
                >
                  <v-list-item-action>
                    <v-icon>{{ menu.icon }}</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>{{ menu.title }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-divider v-if="menu.type=='divider'"></v-divider>

                <v-list-group
                  v-if="menu.type == 'subMenu'"
                  dark
                  active-class="blue--text"
                >
                  <template v-slot:activator>
                    <v-list-item-action>
                      <v-icon class="">{{ menu.icon }}</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title> {{ menu.title }}</v-list-item-title>
                    </v-list-item-content>
                  </template>
                  <v-list-item
                    v-for="(subItem,idx) in menu.submenus"
                    active-class="orange darken-4"
                    :to="subItem.route"
                    :key="idx"
                    v-if="subItem.type === 'item'"
                    class="animate__animated animate__flipInY"
                  >
                    <v-list-item-content>
                      <v-list-item-title>{{ subItem.title }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-group>

                <v-subheader
                  :class="menu.class"
                  :key="index"
                  class="overline mt-3"
                  style="height: 24px"
                  v-else-if="menu.type === 'subheader'"
                >{{ menu.title }}</v-subheader>
              </template>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="9">
        <v-row class="mt-2 ml-5 mr-5">
          <div class="mt-5 body-2">Menampilkan 1 - {{ record.products.length }} produk dari total {{ record.products.length }}</div>
          <v-spacer></v-spacer>
          <div class="mt-3 mr-2">Urutkan : </div>
          <v-select
            class="mt-1"
            outlined
            dense
            hide-detail
            color="blue"
            style="max-width: 300px;"
            :items="urutans"
          ></v-select>
        </v-row>
        <v-row class="mt-5 pl-3">
          <v-col
            cols="3"
            v-for="(item,index) in record.products"
            :kety="index"
            @click="openProductDetail(item.id)"
          >
            <div class="ant-market-box-product">
              <img
                :src="item.image"
                alt=""
                srcset=""
                height="175"
                width="100%"
              >
              <div
                v-show="item.unggulan"
                class="ant-market-product-best"
              >
                UNGGULAN
              </div>
              <div
                style=""
                class="ant-market-box-product-content"
              >
                <div class="pl-2 font-weight-bold">
                  {{ item.price }}
                </div>
                <div class="pl-2">
                  {{ item.name }}
                </div>
                <div class="mt-1">
                  <v-icon
                    small
                    color="blue"
                    class="mr-1"
                  >mdi-home-map-marker</v-icon> {{ record.location }}
                </div>
                <div class="mt-1">
                  <v-icon
                    small
                    color="orange"
                    class="mr-1"
                  >mdi-medal</v-icon> {{ item.rate }} | Review : {{ item.review }}
                </div>
              </div>
            </div>
          </v-col>

        </v-row>
        <v-row class="mt-4">
          <v-col>
            <div class="text-center">
              <v-pagination
                v-model="page"
                :length="1"
                color="blue"
              ></v-pagination>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-dialog
          transition="dialog-bottom-transition"
          v-model="shareproduct.show"
          :max-width="device.desktop ? `600px` : `100%`"
          persistent
          :fullscreen="device.mobile"
        >
          <v-card>
            <v-row class="pa-5">
              <v-col cols="10">
                <div class="ant-font-viga ant-title">
                  Bagikan Dengan Teman Anda..!
                </div>
              </v-col>
              <v-col cols="2">
                <v-row class="pa-2 justify-end">
                  <v-btn
                    icon
                    @click="closeShareProduct"
                  >
                    <v-icon>mdi-close-circle</v-icon>
                  </v-btn>
                </v-row>
              </v-col>
            </v-row>

            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <v-card
                    outlined
                    class="blue lighten-5"
                  >
                    <v-row class="pa-5">
                      <v-col cols="2">
                        <img
                          :src="record.logo"
                          alt=""
                          srcset=""
                          width="50"
                          height="50"
                          style="border-radius: 15px;"
                        >
                      </v-col>
                      <v-col>
                        <div class="font-weight-bold">
                          {{ record.name }}
                        </div>
                        <div>
                          e-tokopkk.bantenprov.go.id
                        </div>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
              <v-row class="mb-5">
                <v-col cols="12">
                  <div class="font-weight-bold">Akan dibagikan lewat mana?</div>
                </v-col>
                <v-col cols="1">
                  <ShareNetwork
                    network="facebook"
                    :url="'https://e-tokopkk.bantenprov.go.id/up2k/'+ $route.params.id"
                    title="UP2K PKK PROVINSI BANTEN"
                    description="UP2K PKK PROVINSI BANTEN"
                    quote="TES"
                    :hashtags="'etokopkk,'+ record.name"
                  >
                    <v-btn icon>
                      <v-icon
                        x-large
                        class="blue--text"
                      >
                        mdi-facebook
                      </v-icon>
                    </v-btn>

                  </ShareNetwork>
                </v-col>
                <v-col cols="1">
                  <ShareNetwork
                    network="whatsapp"
                    :url="'https://e-tokopkk.bantenprov.go.id/up2k/'+ $route.params.id"
                    title="UP2K PKK PROVINSI BANTEN"
                    description="UP2K PKK PROVINSI BANTEN"
                    quote="TES"
                    :hashtags="'etokopkk,'+ record.name"
                  >
                    <v-btn icon>
                      <v-icon
                        x-large
                        class="green--text"
                      >
                        mdi-whatsapp
                      </v-icon>
                    </v-btn>

                  </ShareNetwork>

                </v-col>
                <v-col cols="1">

                  <v-btn icon>
                    <v-icon
                      x-large
                      class="pink--text"
                    >
                      mdi-instagram
                    </v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="1">
                  <ShareNetwork
                    network="Telegram"
                    :url="'https://e-tokopkk.bantenprov.go.id/up2k/'+ $route.params.id"
                    title="UP2K PKK PROVINSI BANTEN"
                    description="UP2K PKK PROVINSI BANTEN"
                    quote="TES"
                    :hashtags="'etokopkk,'+ record.name"
                  >
                    <v-btn icon>
                      <v-icon
                        x-large
                        class="blue--text"
                      >
                        mdi-telegram
                      </v-icon>
                    </v-btn>

                  </ShareNetwork>

                </v-col>
                <v-col cols="1">
                  <v-btn icon>
                    <v-icon
                      x-large
                      class="blue--text"
                    >
                      mdi-twitter
                    </v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="1">
                  <v-btn icon>
                    <v-icon
                      x-large
                      class="grey--text"
                    >
                      mdi-link
                    </v-icon>
                  </v-btn>
                </v-col>

              </v-row>
            </v-card-text>

          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>
      
<script>
import { mapState, mapActions } from "vuex";
import "animate.css";
export default {
  name: "umkm",
  data: () => ({
    tab: null,
    thumbnail: "images/produk5.png",
    page: 1,
    record: {},
    categories: [],

    shareproduct: {
      show: false,
    },
  }),
  mounted() {
    this.setPage({
      crud: false,
    });
    this.fetchRecord();
    this.fetchMenuCategory();
  },

  computed: {
    ...mapState(["device", "theme", "info", "http", "snackbar", "auth"]),
  },
  methods: {
    ...mapActions(["setPage", "signIn"]),
    fetchRecord: async function () {
      try {
        let { data } = await this.http.get(
          "company-show/" + this.$route.params.id
        );
        this.record = data;
      } catch (error) {}
    },
    fetchMenuCategory: async function () {
      let { data } = await this.http.get("menu-category");

      this.categories = data;
    },
    setThumbnail: function (val) {
      this.thumbnail = val;
    },
    postBeliLangsung: function () {
      const url = "https://plazabanten.com";
      window.open(url, "__blank");
    },
    openShareProduct: function () {
      this.shareproduct.show = true;
    },
    closeShareProduct: function () {
      this.shareproduct.show = false;
    },
    openProductDetail: async function (val) {
      this.$router.push({
        name: "product-detail",
        params: {
          id: val,
        },
      });
    },
    openCurrectUrl: function () {
      return window.location.href;
    },
  },
};
</script>
  